export default __webpack_public_path__ + "static/media/bitflow-logo-dark.e8bb1e25.svg";